import {call, put} from 'redux-saga/effects';
import service from './apiService';
import * as Constants from './constants';
import * as GlobalConstants from "../../../systems/globalContant/index";
import bootbox from "../../common/components/Bootbox/bootbox";
import {t} from './../../../systems/i18n/index.js';

export function* fetchAllConfigUser(action) {
    try {
        let response = yield call(service.fetchAllConfigUser, action.payload);
        if (typeof response !== 'undefined' && response.data.code === GlobalConstants.GLOBAL_CONTANT.SUCCESS_CODE) {
            yield put({type: Constants.FETCH_ALL_CONFIG_USER.SUCCESS, payload: response.data});
        } else {
            yield put({type: Constants.FETCH_ALL_CONFIG_USER.FAILED, payload: response.data});
            bootbox.error(t('message.system_errors'));
        }
    } catch (err) {
        bootbox.error(t("message.system_errors") + " : " + err.message);
        yield put({type: Constants.FETCH_ALL_CONFIG_USER.FAILED, payload: {}});
    }
}

export function* updateUserConfig(action) {
    try {
        let response = yield call(service.updateUserConfig, action.payload);
        if (typeof response !== 'undefined' && response.data.code === GlobalConstants.GLOBAL_CONTANT.SUCCESS_CODE) {
            yield put({type: Constants.UPDATE_USER_CONFIG.SUCCESS, payload: response.data});
            bootbox.success(t('setting:update_success'));
        } else {
            yield put({type: Constants.UPDATE_USER_CONFIG.FAILED, payload: response.data});
            bootbox.error(t('message.system_errors'));
        }
    } catch (err) {
        bootbox.error(t("message.system_errors") + " : " + err.message);
        yield put({type: Constants.UPDATE_USER_CONFIG.FAILED, payload: {}});
    }
}